import React from "react";

const Button = ({
  text,
  type = "primary",
  fullWidth = false,
  onClick,
  className,
  icon,
  iconRight,
  disabled,
}) => {
  return (
    <button
      className={`button button-${type} ${fullWidth ? "full-width" : ""} ${
        className || ""
      } flex flex-align-center flex-justify-center`}
      onClick={onClick}
      disabled={disabled}
    >
      {icon || ''}
      <span>{text}</span>
      {iconRight || ''}
    </button>
  );
};

export default Button;
